import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { MonitorPlay } from "lucide-react";
import { useApi, fmtD } from "@/lib/api";
import { brandHex } from "@/lib/brandColor";
import { Card } from "@/components/kit";

function Num({ label, value, sub, testid }) {
  return (
    <div className="rounded-xl bg-slate-50 p-4">
      <div className="ka-eyebrow">{label}</div>
      <div data-testid={testid} className="mt-1 font-display text-3xl font-extrabold text-slate-900">{value}</div>
      {sub && <div className="mt-0.5 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}

export default function DemoStats() {
  const { data } = useApi("/platform/demo-stats");
  if (!data) return <div className="mb-8 h-32 animate-pulse rounded-2xl bg-slate-200/60" />;
  const { d7, d30 } = data;
  const chart = data.chart.map((c) => ({ ...c, label: c.date.slice(8) }));
  return (
    <Card data-testid="demo-stats-card" className="mb-10">
      <h3 className="mb-1 flex items-center gap-2 text-lg font-bold"><MonitorPlay className="h-4 w-4" />Live demo</h3>
      <p className="mb-5 text-sm text-slate-500">Each person counts once per day they open the demo. Sign-ups are new businesses that came from the demo.</p>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Num label="Demo opens · 7 days" value={d7.opens} sub={`${d7.visitors} different people`} testid="demo-stats-opens-7" />
        <Num label="Sign-ups · 7 days" value={d7.signups} sub={`${d7.conversion}% of people`} testid="demo-stats-signups-7" />
        <Num label="Demo opens · 30 days" value={d30.opens} sub={`${d30.visitors} different people`} testid="demo-stats-opens-30" />
        <Num label="Sign-ups · 30 days" value={d30.signups} sub={`${d30.conversion}% of people`} testid="demo-stats-signups-30" />
      </div>
      <div className="mt-6 grid gap-6 lg:grid-cols-[1.4fr_1fr]">
        <div data-testid="demo-stats-chart" className="h-52">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chart}><XAxis dataKey="label" tickLine={false} axisLine={false} fontSize={11} /><YAxis allowDecimals={false} tickLine={false} axisLine={false} fontSize={11} width={28} /><Tooltip cursor={{ fill: "#F1F5F9" }} labelFormatter={(_, p) => (p[0] ? fmtD(p[0].payload.date) : "")} /><Legend iconSize={8} wrapperStyle={{ fontSize: 12 }} /><Bar dataKey="opens" name="Demo opens" fill="#0ea5e9" radius={[4, 4, 0, 0]} /><Bar dataKey="signups" name="Sign-ups" fill={brandHex()} radius={[4, 4, 0, 0]} /></BarChart>
          </ResponsiveContainer>
        </div>
        <div>
          <div className="ka-eyebrow mb-2">Latest sign-ups from the demo</div>
          <ul data-testid="demo-stats-recent" className="divide-y divide-slate-100 text-sm">
            {data.recent.map((b) => <li key={b.id} className="flex justify-between py-2"><span className="font-semibold">{b.name}</span><span className="font-mono text-xs text-slate-500">{fmtD(b.created_at)}</span></li>)}
            {!data.recent.length && <li className="py-3 text-slate-500">No sign-ups from the demo yet.</li>}
          </ul>
        </div>
      </div>
    </Card>
  );
}
